var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"text-center absolute-center"},[_c('SwoopLogo'),_c('h1',[_vm._v("Welcome to ATMOS")])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }